export const WAITING_FOR_APPROVAL_REQUESTS_REMINDER =
  "WAITING_FOR_APPROVAL_REQUESTS_REMINDER";

export interface IMainAbsenceType {
  id: string;
  name: string;
}

export interface IFeatureConfiguration {
  wholeCompany: boolean;
}

export interface ICompanyConfigurationsResponse {
  mainAbsenceType?: IMainAbsenceType | null;
  featuresConfigurations: {
    [key: string]: IFeatureConfiguration;
  };
}

export interface ICompanyConfigurationsRequest {
  mainAbsenceTypeId?: string | null;
  featuresConfigurations: {
    [key: string]: IFeatureConfiguration;
  };
}

export interface IAbsencesConfigurationFormValues {
  mainAbsenceType: { id: string; label: string } | null;
  waitingForApprovalRequestsReminder: boolean;
}
